var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:("width: 100%; height: 100%; min-height: 320px; max-height: 320px; min-width: 200px;"),attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }